import React, {useEffect, useRef, useState, useLayoutEffect} from "react"
import DropdownMenu from "./DropdownMenu"

export default function TabsNavigation(props) {
    const navRef = useRef()
    const [selectedItem, setSelectedItem] = useState(props.currentTab)//NUMBER
    const [loading, setLoading] = useState(true)
    const [tabsValues, setTabsValues] = useState(props.values || [])
    const [dropdown, setDropdown] = useState([])

    useEffect(() => {
        setSelectedItem(props.currentTab)
    }, [props.currentTab])

    useLayoutEffect(() => {
        let _timeOutId = null
        function splitMenus(){
            if(!navRef.current)  return
            setLoading(true)
            let pos = 0
            let menuWidth = 0
            let kidsWidth = 0
            let dropdownValues = []
            menuWidth = navRef.current?.clientWidth || 0
            props.values.forEach((v, i) => {
                if(navRef.current.children?.length > 0) navRef.current.children[i].classList.remove("tab-hidden")
                v.btnClass = props.btnClass || null
                kidsWidth += navRef.current.children[i].clientWidth
                //minus next element width
                let minus= (i > 1 && navRef.current.children[i + 1] ? navRef.current.children[i + 1].clientWidth : 0)
                //last item minus for dropdown
                //Todo detect if has dropdown and then deduct 50
                if(minus === 0) minus = minus + 50
                if(kidsWidth >= menuWidth - minus){
                    if(pos === 0) pos = i
                    if(i > 0) navRef.current.children[i].classList.add("tab-hidden")//hide but not first item
                }
            })
            if(pos > 0){
                dropdownValues = props.values.slice(pos, props.values.length + pos)
                setDropdown(dropdownValues)
            }else {
                setDropdown([])
            }
            setTabsValues(props.values)
            setLoading(false)
        }

        window.addEventListener('resize', ()=> {
            _timeOutId = setTimeout(()=> {
                splitMenus()
            }, 200)
        })
        
        splitMenus()

        return () => {
            window.removeEventListener('resize', ()=> {
                console.log('remove timer')
               _timeOutId = clearTimeout(_timeOutId)
            })
        }

    }, [props.values, props.btnClass])

    function selectMenuItem(val){
        if(selectedItem !== val){
            props.callback(val)
            setSelectedItem(val)
        }
    }

    function renderMenuItems(){
        let outputElements = []
        props.values.forEach(function(v, i){
            outputElements.push(<span key={v.value}
                      onClick={(evt) => {
                            evt.stopPropagation()
                            selectMenuItem(v.value)
                      }}
                      className={(v.required ? "required" : "")
                          + (v.selected ? " active" : "")}
                >
                <p>{v.text}</p>
            </span>)
        })
        return outputElements
    }

    return <div
            ref={navRef}
            onClick={(evt) => {
                evt.stopPropagation()
            }}
            className={"tabs-navigation"
                + (tabsValues.length > 1 ? " has-nav" : "")
                + (props.className ? " " + props.className : "")
                + (props.position ? " " + props.position : "")
            }
        >
        {renderMenuItems()}
        {!loading ? <RenderDropdown items={dropdown} selectedItem={selectedItem} btnClass={props.btnClass} action={val => selectMenuItem(val)} /> : null}
    </div>
}

function RenderDropdown(props){
    const [items, setItems] = useState(props.items)
    const [selectedItem, setSelectedItem] = useState(props.selectedItem)

    useEffect(()=> {
        setSelectedItem(props.selectedItem)
    }, [props.selectedItem])
    useEffect(()=> {
        setItems(props.items)
    }, [props.items])

    if(items.length < 1) return null
    return <DropdownMenu
        btnClass={props.btnClass}
        icon={"ellipsis-v"}
        hideArrow
        values={items}
        onSelect={(val)=> {
            props.action(val)
        }}
        active={items.filter(i => i.value === selectedItem).length > 0}
        currentValue={selectedItem}
        text={false}
        disableLabelOnSelect={true}
        className={"ui-dropdown-align-right"}
    />
}